/* eslint-disable react-hooks/exhaustive-deps */
import { Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core'
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { REQUIRED_MESSAGE } from "../../constants";
import * as yup from "yup";
import { defaultValues } from './models';
import { styles } from "./styles";

const ValidateUserForm = ({ maestras, onSubmit, showRefundForm }) => {
  const classes = styles();
  const [isPassport, setIsPassport] = useState(false);
  const schema = yup.object().shape({
    documentType: yup.string()
            .required(REQUIRED_MESSAGE)
            .typeError(REQUIRED_MESSAGE),
            
    documentNumber: isPassport
            ? yup
                .string()
                .required(REQUIRED_MESSAGE)
                .min(3, "Ingrese mínimo 3 caracteres")
                .max(16, "Ingrese máximo 16 caracteres")
                .matches(
                    /^([0-9A-Za-zÑñ]{0,16})$/,
                    "Ingrese un número de identificación válido"
                )
            : yup
                .string()
                .required(REQUIRED_MESSAGE)
                .min(3, "Ingrese mínimo 3 caracteres")
                .max(16, "Ingrese máximo 16 caracteres")
                .matches(
                    /^([0-9]{0,16})$/,
                    "Ingrese un número de identificación válido"
                ),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "all",
    reValidateMode: "onChange",
  });

  const validateDocumentType = (e) => {
    e.preventDefault();
    const { value } = e.target;
    if (value === "PP") {
      setIsPassport(true);
    } else {
      setIsPassport(false);
    }
    setValue("documentNumber", null);
  }

  const handleUserKeyPressDocumento = (e) => {
    var form = getValues();
    if (form.documentType !== "PP") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  return (
    <>
      <form
        id="generatePermission"
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
      >
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("documentType") &&
                errors["documentType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                Tipo de Documento
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                
                size="small"
                name="documentType"
                render={(props) => (
                  <Select
                    className={classes.formField}
                    label="Tipo de Documento"
                    notched={true}
                    disabled={showRefundForm}
                    inputProps={{
                      name: "documentType",
                      id: "outlined-select-documentType",
                    }}
                    style={{backgroundColor: "#FFFFFF"}}
                    onChange={(e) => {
                      props.onChange(e);
                      validateDocumentType(e);
                    }}
                    value={props.value}
                  >
                    {maestras.tipoDocumnetoIdentificacion.map((document) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={document.key}
                        value={document.key}
                      >
                        {document.value}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("documentType") &&
                  errors["documentType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                disabled={showRefundForm}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "24px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                InputLabelProps={{ shrink: true }}
                label="Número de Documento"
                name="documentNumber"
                size="small"
                onKeyPress={handleUserKeyPressDocumento }
                error={
                  !!errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
                helperText={
                  errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={2}>
            <Button
              disabled={showRefundForm}
              type="submit"
              style={{
                marginBottom: "30px",
                marginTop: "2px",
                backgroundColor: "#7EBDCE",
                color: "#ffffff",
              }}
            >
              CONTINUAR
            </Button>
          </Grid>

        </Grid>
      </form>
    </>
  );
};

export default ValidateUserForm